import React from 'react';

import {HeaderContainer} from './HeaderContainer';
import {ScreenshotEditor} from './ScreenshotEditor'

export class EditorContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showEditor: true,
    }

  }

  componentWillMount(){
    window.scrollTo(0,0)
  }

  onShowEditor = () => {
    this.setState(state => {
      return {
        showEditor: !state.showEditor
      }
    })
  }

  onSubmit = (data) => {
    const image = new Image();
    image.src = data;

    const w = window.open("");
    w.document.write(image.outerHTML);
  }


  render() {
    return <div className="editor-background">
      <HeaderContainer show={true} />
      {this.state.showEditor && <ScreenshotEditor onCancel={this.onShowEditor} onSubmit={this.onSubmit} />}
    </div>
  }
};


// WEBPACK FOOTER //
// ./src/components/EditorContainer.js